var map = {
	"./Discord.svg": 32977,
	"./GitHub.svg": 87902,
	"./Hundred.svg": 78336,
	"./Liquity.svg": 75970,
	"./Medium.svg": 35808,
	"./Twitter.svg": 47946,
	"./Vesta.svg": 98550,
	"./cb-logo.svg": 76968
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 85959;